<template>
  <div class="mx-2 pt-2 py-2" style="background-color: #f9f9f9; height: 100vh">
    <h1 class="flex justify-center text-2xl 100vh mb-5 pt-10">
      Update Daily Roaster
    </h1>
    <form class="max-w-md mx-auto" @submit.prevent="submit">
      <div class="mb-5">
        <label for="text" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
          Date</label>
        <div date-rangepicker class="md:pt-0 pt-5 flex-wrap">
          <div class="relative">
            <input name="start" type="date" v-model="startDate"
              class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              placeholder="Select Date From" />
          </div>
        </div>
      </div>
      <div class="mb-5">
        <label for="countries" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Select Shift</label>
        <select v-model="shift_id" style="height: 40px"
          class="bg-white rounded-lg border mt-5 md:pt-0 mr-3 border-gray-300 text-gray-900 text-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-bg-save dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
          <option value="">Select shift</option>
          <option v-for="shift in selectshift" :key="shift.id" :value="shift.id">
            {{ shift.shift }}
          </option>
        </select>
      </div>
      <div class="mb-5">
        <label for="text" class="block mb-2 text-sm font-medium text-black dark:text-white">
          All Cities</label>
        <select @change="countryChanged" v-model="selectDistrictid" id="selectDistrictid"
          class="font-family-card text-[16px] rounded bg-white border mb-3 border-gray-300 text-black text-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
          <option selected value="all">All Cities</option>
          <option v-for="district in selectDistrict" :key="district.id" :value="district.id">
            {{ district.name }}
          </option>
        </select>
      </div>
      <div class="mb-5">
        <label for="countries" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Select
          Hospital</label>
        <select ref="staffHospital" multiple v-model="hospital_id" id="hospitals" style="height: 40px"
          class="bg-white rounded-lg border mt-5 md:pt-0 mr-3 border-gray-300 text-gray-900 text-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-bg-save dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
          <option value="">Select Hospital</option>
          <option v-for="hospital in countries" :key="hospital.id" :value="hospital.id">
            {{ hospital.name }}
          </option>
        </select>
      </div>
      <div class="mb-5">
        <label for="countries" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Select staff</label>
        <select v-model="staffCode" style="height: 40px"
          class="bg-white rounded-lg border mt-5 md:pt-0 mr-3 border-gray-300 text-gray-900 text-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-bg-save dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
          <!-- <option :value="staffCode" selected>{{ staffCode }}</option> -->
          <option v-for="staf in staff" :key="staf.id" :value="staf.id">
            {{ staf?.name }} - {{ staf.type }}
          </option>
        </select>
      </div>
      <div class="mb-5" v-if="teamshow">
        <label for="text" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
          Team</label>
        <input type="text" v-model="team" id="username"
          class="shadow-sm bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light"
          placeholder="Team" required />
      </div>
      <div class="flex items-center mt-5 justify-center">
        <router-link to="dailyroaster"
          class="text-white mb-5 bg-button-blue focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
          Back</router-link>
        <button type="submit"
          class="text-white mb-5 ml-5 bg-bg-save focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
          Update Daily Roaster
        </button>
      </div>
    </form>
  </div>
</template>

<script setup>
import { ref, watch, computed, onMounted, onUnmounted } from "vue";
import Swal from "sweetalert2";
import axiosInstce from "@/plugins/axios";
import { useRouter } from "vue-router";
import { useAuthService } from "@/store/Auth"; //  auth.js file
const authStore = useAuthService();

const router = useRouter(); // Initialize the router object
const roasterId = ref();
const selectHospitals = ref([]);
const hospital_id = ref([]);
const staff = ref([]);
const staff_id = ref();
const teamshow = ref(false);
const selectshift = ref([]);
const shift_id = ref();
const startDate = ref();
const team = ref();
const staff_types = ref();
const staffCode = ref();
const staffname = ref();
const stafHospital = ref();
const selectDistrict = ref([]);
const selectDistrictid = ref("all");
const countries = ref([]);
import $ from "jquery";
import "select2";
watch(
  () => staff_types.value,
  (newData) => {
    if (newData === "Collector") {
      teamshow.value = true;
    } else {
      teamshow.value = false;
    }
  }
);
watch(
  () => staffCode.value,
  (newData) => {
    const selectedStaff = staff.value.find(
      (staf) => staf.id === Number(newData)
    );
    const isCollector = selectedStaff && selectedStaff.type === "Collector";
    if (isCollector !== teamshow.value) {
      teamshow.value = isCollector;
    }
  }
);
const getHospitals = () => {
  const hospitalId = 100000000;
  axiosInstce
    .get(`/hospitals/${selectDistrictid.value}`)
    .then((response) => {
      // console.log('Hospitals API response:', response.data.data);
      const hospital = response.data.data.data;
      const districtNames = hospital.map((hospitals) => hospitals);
      countries.value = districtNames;
    })
    .catch((error) => {
      console.error("Error fetching hospitals:", error);
    });
};
const fetchCountries = async () => {
  try {
    const response = await axiosInstce.get("/all-districts"); // Replace with your API endpoint
    const districts = response.data.data;
    countryChanged();
    // Extracting all district names
    const districtNames = districts.map((district) => district);
    selectDistrict.value = districtNames;
  } catch (error) {
    console.error("Error fetching countries:", error);
    // Handle error or show error message
  }
};
const countryChanged = async () => {
  try {
    const response = await axiosInstce.get(
      `/districts/${selectDistrictid.value}/incineration-hospitals`
    );
    const countery = response.data.data;
    const counterys = countery.map((countery) => countery);
    countries.value = counterys;
  } catch (error) {
    console.error("Error fetching district info:", error);
    // Handle error or show error message
  }
};
const getdailyroasterid = () => {
  const hospitalId = 100000000;
  axiosInstce
    .get(`/daily-roaster-detail/${roasterId.value}`)
    .then((response) => {
      // console.log('nowwwwwwww API response:', response.data.data.data[0].date);
      startDate.value = response?.data?.data?.dailyRoaster?.date;
      shift_id.value = response?.data?.data?.dailyRoaster?.shift?.id;
      staff_types.value =
        response?.data?.data?.dailyRoaster.staff?.staff_type?.type;
      team.value = response?.data?.data?.dailyRoaster?.team;
      hospital_id.value.push(response?.data?.data?.dailyRoaster?.hospital?.id);
      stafHospital.value = response?.data?.data?.dailyRoaster?.hospital?.id;
      gethospitalstaff(response?.data?.data?.dailyRoaster?.hospital?.id);
      staffCode.value = response?.data?.data?.dailyRoaster.staff?.id;
      selectDistrictid.value =
        response?.data?.data.dailyRoaster.hospital?.tehsil?.district?.id;
      // console.log(response?.data?.data?.dailyRoaster.staff?.staff_type.code,'curennnnnnnnnt');
    })
    .catch((error) => {
      console.error("Error fetching hospitals:", error);
    });
};
const getShift = () => {
  const shiftid = 100000000;
  axiosInstce
    .get(`/shifts-paginate/${shiftid}`)
    .then((response) => {
      // console.log('shiftt API response:', response.data.data);
      selectshift.value = response.data.data.data;
    })
    .catch((error) => {
      console.error("Error fetching hospitals:", error);
    });
};
const getstaff = () => {
  axiosInstce
    .get(`/hospitals/${hospital_id.value}/staffs/`)
    .then((response) => {
      const shift = response.data.data;
      const districtNames = shift.map((hospitals) => hospitals);
      staff.value = districtNames;
      // staffCode.value = staffname.value
      // console.log('current API response:', districtNames);
      // selectHospitals.value = districtNames;
    })
    .catch((error) => {
      console.error("Error fetching hospitals:", error);
    });
};
const gethospitalstaff = (id) => {
  axiosInstce
    .get(`/hospitals/${id}/staffs/`)
    .then((response) => {
      const shift = response.data.data;
      const districtNames = shift.map((hospitals) => hospitals);
      staff.value = districtNames;
      // staffCode.value = staffname.value
      // console.log('current API response:', districtNames);
      // selectHospitals.value = districtNames;
    })
    .catch((error) => {
      console.error("Error fetching hospitals:", error);
    });
};
const changehospital = () => {
  getstaff()
  // staff_id.value = $("#hospitals").val();
};
const submit = async () => {
  try {
    const selectedHospitals = $("#hospitals").val();
    if (selectedHospitals && selectedHospitals.length > 1) {
      // Show a warning message
      Swal.fire({
        title: "Warning",
        text: "Please select only one hospital.",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return; // Stop further execution
    }
    const response = await axiosInstce.put(
      `/daily-roaster/${roasterId.value}`,
      {
        date: startDate.value,
        staff_id: staffCode.value,
        hospital_id: selectedHospitals[0],
        shift_id: shift_id.value,
        team: team.value,
      }
    );
    Swal.fire({
      toast: true,
      title: "DailyRoaster Updated successfully.",
      icon: "success",
      position: "top-end",
      showConfirmButton: false,
      timer: 2000,
      timerProgressBar: true,
    });
    router.push({ name: "DailyRoaster" });
  } catch (error) {
    console.error("Error fetching DailyRoaster info:", error);
    Swal.fire({
      toast: true,
      title: error.response.data.message,
      icon: "error",
      position: "top-end",
      showConfirmButton: false,
      timer: 2000,
      timerProgressBar: true,
    });
  }
  // form.value = '';
};
onMounted(() => {
  const id = router.currentRoute.value.params.id;
  roasterId.value = id;
  getShift();
  getHospitals();
  getdailyroasterid();
});
$(document).ready(function () {
  // Initialize Select2 for Select 1
  $("#hospitals").select2({
    placeholder: "Select Hospital",
    allowClear: true,
  });
});
// const staffSelect = ref(null)
// const staffHospital = ref(null)

onMounted(() => {
  // $(staffSelect.value).select2();
  // $(staffHospital.value).select2();

  // $(staffSelect.value).on("change", () => {
  //   changestaff();
  // });
  // $(staffHospital.value).on("change", () => {
  //   changehospital();
  // });
  // const id = router.currentRoute.value.params.id;
  // roleId.value = id
  // getShift();
  // getHospitals();
});
onMounted(async () => {
  await fetchCountries();

  await authStore.handlepermission();
});

onUnmounted(async () => {
  await authStore.handlepermission();
});
</script>